module.exports = __webpack_public_path__ + "img/75019de012a365f0a39f8acec72384c0.png";